import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Pré-carrega em segundo plano os chunks das telas internas após o login,
 * usando requestIdleCallback. Assim, ao clicar em um item do menu,
 * a página abre instantaneamente (sem download de JS).
 *
 * Só executa em rotas autenticadas (/partner, /admin, /dashboard).
 */
const RoutePrefetcher = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isAuthenticated =
      pathname.startsWith("/partner") ||
      pathname.startsWith("/admin") ||
      pathname.startsWith("/dashboard");

    if (!isAuthenticated) return;

    const isAdmin = pathname.startsWith("/admin");

    const prefetch = () => {
      if (isAdmin) {
        import("@/pages/admin/AdminDashboard");
        import("@/pages/admin/AdminParceiros");
        import("@/pages/admin/AdminOportunidades");
        import("@/pages/admin/AdminComissoes");
        import("@/pages/admin/AdminServicos");
        import("@/pages/admin/AdminFinanceiroDRE");
        import("@/pages/admin/AdminFinanceiroCaixa");
        import("@/pages/admin/AdminFinanceiroCashFlow");
        import("@/pages/admin/AdminFinanceiroAging");
        import("@/pages/admin/AdminFinanceiroUnitEconomics");
        import("@/pages/admin/AdminFinanceiroIndicacoes");
        import("@/pages/admin/AdminMetas");
        import("@/pages/admin/AdminPlanos");
        import("@/pages/admin/AdminAtendimento");
        import("@/pages/admin/AdminSimulador");
        import("@/pages/admin/AdminMarketing");
      } else {
        import("@/pages/Dashboard");
        import("@/pages/partner/PartnerClientes");
        import("@/pages/partner/PartnerOportunidades");
        import("@/pages/partner/PartnerComissoes");
        import("@/pages/partner/PartnerCRM");
        import("@/pages/partner/PartnerKanban");
        import("@/pages/partner/PartnerAtendimento");
        import("@/pages/partner/PartnerSimulador");
        import("@/pages/partner/PartnerIndicacoes");
        import("@/pages/partner/PartnerMarketing");
        import("@/pages/partner/PartnerMeusDados");
        import("@/pages/partner/PartnerAssinatura");
      }
    };

    const w = window as any;
    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(prefetch, { timeout: 2000 });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = setTimeout(prefetch, 1500);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
};

export default RoutePrefetcher;
